export const getLastThreeFinancialYears = (): {
  label: string;
  value: string;
}[] => {
  const currentYear = new Date().getFullYear();
  const currentMonth = new Date().getMonth();

  // Determine the current financial year
  const startYear = currentMonth < 3 ? currentYear - 1 : currentYear;

  return Array.from({ length: 3 }, (_, i) => {
    const year1 = startYear - i;
    const year2 = (startYear - i + 1) % 100;
    const range = `${year1}-${year2}`;
    return { label: range, value: range };
  });
};
